import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'
/**
 * Crew invitation header component
 */
@Component({
  selector: 'ngx-invite-header',
  templateUrl: './invite-header.component.html',
  styleUrls: ['./invite-header.component.scss'],
  imports: [CommonModule, MatIconModule]
})
export class InviteHeaderComponent {
  /**
   * Creates the component and injects it's dependencies
   * @param router Router
   */
  constructor(private router: Router) {}

  /**
   * Navigates back to event timeline
   */
  backToEvents() {
    this.router.navigate(['events', 'list'])
  }
}
